module.exports = __webpack_public_path__ + "static/logo_dark-62fa180c240f833f3c24c5b01025a164.png";